import React from "react";
interface SkeletonContainerProps {
  classNames: ClassTypes;
  style: React.CSSProperties;
}
const SkeletonContainer = ({
  classNames,
  style
}: SkeletonContainerProps) => {
  return <div className={classNames} style={style} data-sentry-component="SkeletonContainer" data-sentry-source-file="SkeletonContainer.tsx" />;
};
export default SkeletonContainer;